<template>
  <app-overlay-loader v-if="preloader"/>
  <form v-else @submit.prevent="submitData" ref="form" :data-url="apiUrl.REWARD_SETTINGS">
    <app-form-group
        :label="$t('manual_points')"
        v-model="formData.manual_points"
        page="page"
        type="switch"
        :error-message="$errorMessage(errors, 'manual_points')"
        label-alignment="top">
      <template slot="suggestion">
        {{ manual_points_note }}
      </template>
    </app-form-group>
    <app-form-group
        page="page"
        :label="$t('how_to_shop')"
        type="text"
        v-model="formData.how_to_shop"
        :error-message="$errorMessage(errors, 'how_to_shop')"
    />
    <app-form-group
        page="page"
        :label="$t('points_on_time')"
        type="decimal"
        v-model="formData.points_on_time"
        :error-message="$errorMessage(errors, 'points_on_time')"
    />
    <app-form-group
        page="page"
        :label="$t('points_before_time')"
        type="decimal"
        v-model="formData.points_before_time"
        :error-message="$errorMessage(errors, 'points_before_time')"
    />
    <app-form-group
        page="page"
        :label="$t('points_after_time')"
        type="decimal"
        v-model="formData.points_after_time"
        :error-message="$errorMessage(errors, 'points_after_time')"
    />
    <app-form-group
        page="page"
        :label="$t('points_on_renewal')"
        type="decimal"
        v-model="formData.points_on_renewal"
        :error-message="$errorMessage(errors, 'points_on_renewal')"
    />
    <div class="row">
      <div class="col-3"></div>
      <div class="col-9">
        <app-submit-button :label="$t('save')" :loading="loading" @click="submitData"/>
      </div>
    </div>
  </form>
</template>

<script>
import FormHelperMixins from "../../../../../common/Mixin/Global/FormHelperMixins";
import {axiosGet} from "../../../../../common/Helper/AxiosHelper";

export default {
  name: "TickInSettings",
  mixins: [FormHelperMixins],
  data() {
    return {
      formData: {
        how_to_shop: '',
        points_on_time: '',
        points_before_time: '',
        points_after_time: '',
        points_on_renewal: '',
        manual_points: false,
      },
      manual_points_note: this.$t('manual_points_note')
    }
  },
  methods: {
    afterSuccess(response) {
      this.toastAndReload(response.data.message)
    },
    getSetting() {
      this.preloader = true;
      axiosGet(this.apiUrl.REWARD_SETTINGS).then(({data}) => {
        this.formData = {
          how_to_shop: data.how_to_shop ?? '',
          points_on_time: data.points_on_time ? JSON.parse(data.points_on_time) : '',
          points_before_time: data.points_before_time ? JSON.parse(data.points_before_time) : '',
          points_after_time: data.points_after_time ? JSON.parse(data.points_after_time) : '',
          points_on_renewal: data.points_on_renewal ? JSON.parse(data.points_on_renewal) : '',
          manual_points: Boolean(parseInt(data.manual_points))
        }
      }).finally(() => {
        this.preloader = false;
      })
    }
  },
  mounted() {
    this.getSetting();
  },
  watch: {
  }
}
</script>